import * as React from "react";
import { styled } from "utils";
import type { InferGetStaticPropsType, NextPage } from "next";
import { usePropertySearch } from "hooks/usePropertySearch";
import { useRouter } from "next/router";
import {
  Navigation,
  Page,
  Footer,
  Main,
  Box,
  SearchCard,
  PropertyList,
  Heading,
} from "components";
import * as data from "data";

const StyledSearchCard = styled(SearchCard, {
  backgroundColor: "$white",
  marginX: "auto",
  marginBottom: "$7",
  maxWidth: 857,
  padding: "$5",
});

type Props = InferGetStaticPropsType<typeof getStaticProps>;

const Properties: NextPage<Props> = ({ properties }) => {
  const [filteredProperties, handleSearch] = usePropertySearch(properties);

  const router = useRouter();
  const querySearch = (router.query.searchTerm as string) || "";
  React.useEffect(
    function updateOnSearchRedirect() {
      if (querySearch) {
        handleSearch(querySearch);
      }
    },
    [handleSearch, querySearch]
  );

  return (
    <Page>
      <Navigation />
      <Main>
        <Box as="article">
          <Heading css={{ marginBottom: "$3" }}>Propiedades</Heading>
          <StyledSearchCard
            initialValue={querySearch}
            onSearch={handleSearch}
            css={{ marginBottom: "$6" }}
          />
          <PropertyList properties={filteredProperties} />
        </Box>
      </Main>
      <Footer />
    </Page>
  );
};

export const getStaticProps = async () => {
  return { props: { properties: data.properties } };
};

export default Properties;
